import axios from "../../../../api/axios"
import { tokenHeader } from "../../../../api/tokenHeader"

export const getMyDashboardData = async (accessToken) => {
    const res = await axios.get("dev/me/dashboard", tokenHeader(accessToken))
    console.log(res.data)
    return res.data
}